module.exports = __webpack_public_path__ + "img/man-in-saleshat.0e5bf3a.webp";